
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class BusinessDtoModel extends Model<BusinessDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'zip', type: 'string' },
		{ name: 'phone', type: 'string' },
		{ name: 'homepage', type: 'string' },
		{ name: 'email', type: 'string' },
		{ name: 'businessId', type: 'string' },
		{ name: 'industryCodes', type: 'string[]', isArray: true },
		{ name: 'formOfCompany', type: 'string' },
		{ name: 'foundationDate', type: 'string' },
		{ name: 'domain', type: 'string' }
	];
	[key: string]: any;
	
	public name: string;
	public address: string;
	public city: string;
	public zip: string;
	public phone: string;
	public homepage: string;
	public email: string;
	public businessId: string;
	public industryCodes: string[];
	public formOfCompany: string;
	public foundationDate: string;
	public domain: string;
    
	constructor(){
		super();
		this.name = '';
		this.address = '';
		this.city = '';
		this.zip = '';
		this.phone = '';
		this.homepage = '';
		this.email = '';
		this.businessId = '';
		this.industryCodes = [];
		this.formOfCompany = '';
		this.foundationDate = '';
		this.domain = '';
		
	}
	getProperties(){
		return BusinessDtoModel.classProperties;
	}
}

